import * as actions from './promoConstants';
import { IPromoReducerState } from 'app/modules/promo/promoTypes';
import { ReduxTypes } from 'app/store/redux';
import * as promoActions from './promoActions';

const initialState: IPromoReducerState = {
	promos: [],
	promoItem: null,
	error: null,
	isPromosFetching: false,
	isPromoItemFetching: false,
};

const promoReducer = (
	state: IPromoReducerState = initialState,
	action: ReturnType<ReduxTypes.InferValueTypes<typeof promoActions>>
): IPromoReducerState => {
	switch (action.type) {
		case actions.SET_PROMO_IS_FETCHING:
			return {
				...state,
				isPromosFetching: true
			};
		case actions.GET_PROMOS_SUCCESS:
			return {
				...state,
				promos: action.payload,
				isPromosFetching: false
			};
		case actions.GET_PROMOS_FAIL:
			return {
				...state,
				isPromosFetching: false,
				error: action.error
			};

		case actions.GET_PROMO_ITEM_SUCCESS:
			return {
				...state,
				promoItem: action.promoItem,
				isPromoItemFetching: false
			};

		case actions.RESET_PROMOS:
			return initialState;
		default:
			return state;
	}
};

export default promoReducer;
